import { render, staticRenderFns } from "./ChipDrawer.vue?vue&type=template&id=12f18184&scoped=true&"
import script from "./ChipDrawer.vue?vue&type=script&lang=js&"
export * from "./ChipDrawer.vue?vue&type=script&lang=js&"
import style0 from "./ChipDrawer.vue?vue&type=style&index=0&id=12f18184&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f18184",
  null
  
)

export default component.exports